export  const removeBaseUrl = (url) =>{
    const baseUrl = "https://www.alinealawpllc.com/";
    try {
        const urlObj = new URL(url);
        const baseUrlObj = new URL(baseUrl);
    
        if (urlObj.hostname === baseUrlObj.hostname) {
            return urlObj.pathname + urlObj.search + urlObj.hash;
        }
        return url?.length < 1 ? "/" : url;
    } catch (err) {
        return url;
    }
}
